interface Props {
  html: string;
}

export function CmsContent({ html }: Props) {
  return (
    <div
      className="cms-content"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
